import { colors } from '@sweep-io/sweep-design';
import useConfirm from '../common/dialogs/ConfirmLeaveWithoutSave/useConfirm';
import ConfirmDestructiveDialog from '../common/dialogs/ConfirmDestructiveDialog';
import { ActionsMenuItem } from '../common/actions-menu/ActionsMenuItem';
import { useState } from 'react';

const ChatMenuActions = ({
  closeMenu,
  onRename,
  onDelete,
  togglePin,
  isStarred,
  onExportToPdf,
  onShare,
}: {
  onRename: () => void;
  onDelete: () => void;
  closeMenu: () => void;
  togglePin: () => void;
  isStarred: boolean;
  onExportToPdf?: () => Promise<boolean>;
  onShare?: () => void;
}) => {
  const { openConfirm, onCancel, onConfirm } = useConfirm();
  const [isExporting, setIsExporting] = useState(false);

  const onDeleteClick = async () => {
    const isConfirmed = await openConfirm(
      <ConfirmDestructiveDialog
        open
        onConfirm={onConfirm}
        onClose={onCancel}
        title="Delete chat?"
        confirmText="Delete"
        cancelText="Cancel"
      >
        You'll no longer see this chat here
      </ConfirmDestructiveDialog>,
    );
    if (isConfirmed) {
      onDelete();
    }
  };

  const handleExportToPdf = async () => {
    if (!onExportToPdf) return;
    
    setIsExporting(true);
    try {
      await onExportToPdf();
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      <ActionsMenuItem
        action={{
          label: isStarred ? 'Unstar' : 'Star',
          value: isStarred ? 'Unstar' : 'Star',
        }}
        handleClose={closeMenu}
        onClick={togglePin}
        key="Pin"
      />
      <ActionsMenuItem
        action={{
          label: 'Rename',
          value: 'Rename',
        }}
        handleClose={closeMenu}
        onClick={onRename}
        key="Rename"
      />
      {onExportToPdf && (
        <ActionsMenuItem
          action={{
            label: 'Export to PDF',
            value: 'Export to PDF',
            disabled: isExporting,
          }}
          handleClose={closeMenu}
          onClick={handleExportToPdf}
          key="ExportToPdf"
        />
      )}
      {onShare && (
        <ActionsMenuItem
          action={{
            label: 'Share',
            value: 'Share',
          }}
          handleClose={closeMenu}
          onClick={onShare}
          key="Share"
        />
      )}
      <ActionsMenuItem
        action={{
          label: 'Delete',
          value: 'Delete',
          actionSx: { color: colors.blush[600] },
        }}
        handleClose={closeMenu}
        onClick={onDeleteClick}
        key="Delete"
      />
    </>
  );
};
export default ChatMenuActions;
